module.exports = __webpack_public_path__ + "img/img-tennis.977a9ff3.png";